module.exports = __webpack_public_path__ + "img/chainlink.74594e10.png";